import React from "react";
import Layout from "../../../components/layouts/Layout";
import EmailShare from '../components/ShocialShareGraph/Email/EmailShare'
import SmsShare from '../components/ShocialShareGraph/Sms/SmsShare'
import MicrositeShare from '../components/ShocialShareGraph/Microsite/MicrositeShare'
import FacebookShare from '../components/ShocialShareGraph/Facebook/FacebookShare'
import TwitterShare from '../components/ShocialShareGraph/Twitter/TwitterShare'
import InstagramShare from '../components/ShocialShareGraph/Instagram/InstagramShare'
import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip } from 'recharts';
import '../style/dashboard.css';
import Chart from "../../../components/Rechart/Chart";
import { useEffect } from "react";
import { useState } from "react";
import http, { URL_S3 } from "../../../config/BaseUrl";
import { useParams } from "react-router-dom";
import RecentGifs from "./galleryItem/RecentGifs";
import RecentPhoto from "./galleryItem/RecentPhoto";


function Analytic() {


  const data = {
    weeklyData: [
      { name: 'Day 1', share: 10, pv: 2400, amt: 2400 },
      { name: 'Day 2', share: 25, pv: 2400, amt: 2400 },
      { name: 'Day 3', share: 15, pv: 2400, amt: 2400 },
      { name: 'Day 4', share: 30, pv: 2400, amt: 2400 },
      { name: 'Day 5', share: 30, pv: 2400, amt: 2400 },
      { name: 'Day 6', share: 30, pv: 2400, amt: 2400 },
      { name: 'Day 7', share: 30, pv: 2400, amt: 2400 }
    ],
    monthlyData: [
      { name: 'Week 1', share: 25, pv: 2400, amt: 2400 },
      { name: 'Week 2', share: 50, pv: 2400, amt: 2400 },
      { name: 'Week 3', share: 18, pv: 2400, amt: 2400 },
      { name: 'Week 4', share: 55, pv: 2400, amt: 2400 },
    ],
    yearlyData: [
      { name: 'M 1', share: 100, pv: 2400, amt: 2400 },
      { name: 'M 2', share: 250, pv: 2400, amt: 2400 },
      { name: 'M 3', share: 150, pv: 2400, amt: 2400 },
      { name: 'M 4', share: 300, pv: 2400, amt: 2400 },
      { name: 'M 5', share: 300, pv: 2400, amt: 2400 },
      { name: 'M 6', share: 300, pv: 2400, amt: 2400 },
      { name: 'M 7', share: 300, pv: 2400, amt: 2400 },
      { name: 'M 8', share: 300, pv: 2400, amt: 2400 },
      { name: 'M 9', share: 300, pv: 2400, amt: 2400 },
      { name: 'M 10', share: 300, pv: 2400, amt: 2400 },
      { name: 'M 11', share: 300, pv: 2400, amt: 2400 },
      { name: 'M 12', share: 300, pv: 2400, amt: 2400 }
    ]
  }

  const { id } = useParams()
  const [loading, setLoading] = useState(false);
  const [recentGallery, setRecentGallery] = useState([]);
  const [socialShare, setSocialShare] = useState([]);
  const [galleryTab, setGalleryTab] = useState("photo");
  const [eventStatus, setStatus] = useState('most_viewed')


  // ================Social Share Api Fetch==================

  const fetchSocialShareSingle = async () => {
    try {
      http.get(`event-social-share/${id}`).then((res) => {
        if (res.data) {
          setSocialShare(res.data.single_social_share)
        }
      })
    } catch (error) {

    }
  }


  // ================Social Gallery Api Fetch================== 

  const fetchRecentGallery = async (params) => {
    try {
      setLoading(true)
      http.get(`gallery-items-single/${id}`, { params }).then((res) => {
        if (res.data) {
          setRecentGallery(res.data.gallery_photo_single)
          setLoading(false)
        }
      }).catch((err) => {
        setLoading(false)
      })
    } catch (error) {
      setLoading(false)
    }
  }


  // =================================

  const [isLoading, setIsLoading] = useState(false);
  const [eventGraph, setEventGraph] = useState("");

  const fetchGraphData = async () => {
    try {
      setIsLoading(true)
      await http.get(`event-analytics/sharing-graph/${id}`).then(res => {
        if (res.data.graphData) {
          setIsLoading(false)
          setEventGraph(res.data.graphData)
        }
      }).catch((err) => {
        console.log('fail');
        setIsLoading(false)
      })
    } catch (error) {

    }
  }

  const graphTotalText = {
    week: `This Week`,
    month: 'This Month',
    year: 'This Year'
  }


  useEffect(() => {
    const params = {
      gallery_item: galleryTab
    }
    fetchRecentGallery(params)
    fetchSocialShareSingle()
    fetchGraphData()
  }, [galleryTab])



  return (
    <Layout>
      <div className="page">
        <div className="row">

          <div className="col-12">
            <div className="card radius-10">
              <div className="card-body">
                <Chart
                  loading={isLoading}
                  graphTotalText={graphTotalText}
                  sectionTitle={"Event Analytics"}
                  sectionName={"analytic-capture"}
                  dataSet={eventGraph}
                  width={1200}
                  height={350}
                  dataKey={"share"}
                  navClass={"justify-content-end analytic-nav"}
                />
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-12 col-xl-12">
            <div class="card radius-15">
              <div class="card-body">
                <div class="d-lg-flex align-items-center mb-4">
                  <div>
                    <h5 class="mb-0">Social Share</h5>
                  </div>
                  <div class="ml-auto">
                    <h3 class="mb-0">
                      <span class="font-14">Total Share:</span> {socialShare && socialShare.total_share}
                    </h3>
                  </div>
                </div>
                <hr />
                <div class="dashboard-social-list social-share-list">
                  <div className="row">
                    <div className="col-4 col-sm-3 col-md-2 col-lg-2 col xl-2">
                      <div class="d-flex flex-column align-items-center justify-content-center text-center">
                        <div class="widgets-social bg-primary text-white mb-1 social-share-item">
                          <i class="bx bx-envelope"></i>
                        </div>
                        <div class="media-body">
                          <h4 class=""> {socialShare && socialShare.email}</h4>
                          <p class="text-secondary font-weight-bold pt-0">Email</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-4 col-sm-3 col-md-2 col-lg-2 col xl-2">
                      <div class="d-flex flex-column align-items-center justify-content-center text-center">
                        <div class="widgets-social bg-primary text-white mb-1 social-share-item">
                          <i class="bx bx-message-detail"></i>
                        </div>
                        <div class="media-body">
                          <h4 class="">{socialShare && socialShare.sms}</h4>
                          <p class="text-secondary font-weight-bold pt-0">SMS</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-4 col-sm-3 col-md-2 col-lg-2 col xl-2">
                      <div class="d-flex flex-column align-items-center justify-content-center text-center">
                        <div class="widgets-social bg-primary text-white mb-1 social-share-item">
                          <i class="lni lni-facebook"></i>
                        </div>
                        <div class="media-body">
                          <h4 class="">{socialShare && socialShare.facebook}</h4>
                          <p class="text-secondary font-weight-bold pt-0">Facebook</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-4 col-sm-3 col-md-2 col-lg-2 col xl-2">
                      <div class="d-flex flex-column align-items-center justify-content-center text-center">
                        <div class="widgets-social bg-primary text-white mb-1 social-share-item">
                          <i class="lni lni-twitter"></i>
                        </div>
                        <div class="media-body">
                          <h4 class="">{socialShare && socialShare.twitter}</h4>
                          <p class="text-secondary font-weight-bold pt-0">Twitter</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-4 col-sm-3 col-md-2 col-lg-2 col xl-2">
                      <div class="d-flex flex-column align-items-center justify-content-center text-center">
                        <div class="widgets-social bg-primary text-white mb-1 social-share-item">
                          <i class="lni lni-instagram"></i>
                        </div>
                        <div class="media-body">
                          <h4 class="">{socialShare && socialShare.instagram}</h4>
                          <p class="text-secondary font-weight-bold pt-0">Instagram</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-4 col-sm-3 col-md-2 col-lg-2 col xl-2">
                      <div class="d-flex flex-column align-items-center justify-content-center text-center">
                        <div class="widgets-social bg-primary text-white mb-1 social-share-item">
                          <i class="lni lni-linkedin"></i>
                        </div>
                        <div class="media-body">
                          <h4 class="">{socialShare && socialShare.microsite}</h4>
                          <p class="text-secondary font-weight-bold pt-0">Linked In</p>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-4 col-lg-4 col-xl-4">
            <div class="card radius-15">
              <div class="card-body">
                <EmailShare eventId={id} />
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 col-lg-4 col-xl-4">
            <div class="card radius-15">
              <div class="card-body">
                <SmsShare eventId={id} />
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 col-lg-4 col-xl-4">
            <div class="card radius-15">
              <div class="card-body">
                <FacebookShare eventId={id} />
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 col-lg-4 col-xl-4">
            <div class="card radius-15">
              <div class="card-body">
                <TwitterShare eventId={id} />
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 col-lg-4 col-xl-4">
            <div class="card radius-15">
              <div class="card-body">
                <InstagramShare eventId={id} />
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 col-lg-4 col-xl-4">
            <div class="card radius-15">
              <div class="card-body">
                <MicrositeShare eventId={id} />
              </div>
            </div>
          </div>

        </div>

        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <div className="pt-2 photos">
                  <div className="row">
                    <div className="col-12">
                      <h2>
                        <span className="font-size-18 text-secondary">
                          <i className="bx bx-image"></i>
                        </span>
                        {" "}
                        <span className="text-primary text-uppercase font-weight-bold font-size-18">Gallery Overview</span>
                      </h2>
                    </div>

                    <div className="col-12">
                      <div className="row">

                        <div className="col-12">
                          <div className="tab-items-section">
                            <div className="section-tab-status">
                              <p className="text-secondary">Categories :</p>
                            </div>
                            <div className="section-tab-body">
                              <div className="tab-body">

                                <div className="tab-items">
                                  <span
                                    className={eventStatus == 'most_viewed' && `active`}
                                    onClick={e => { setStatus('most_viewed') }}
                                  >Most Viewed</span>
                                </div>

                                <div className="tab-items">
                                  <span
                                    className={eventStatus == 'recent_photo' && `active`}
                                    onClick={e => { setStatus('recent_photo'); setGalleryTab("photo") }}
                                  >Recent Photos</span>
                                </div>
                                {/* 
                                <div className="tab-items">
                                  <span
                                    className={eventStatus == 'recent_gifs' && `active`}
                                    onClick={e =>{ setStatus('recent_gifs'); setGalleryTab("gif")}}
                                  >Recent Gifs</span>
                                </div> */}

                                <div className="tab-items">
                                  <span
                                    className={eventStatus == 'recent_video' && `active`}
                                    onClick={e => { setStatus('recent_video'); setGalleryTab("video") }}
                                  >Recent Video</span>
                                </div>
                                <div className="tab-items">
                                  <span
                                    className={eventStatus == 'recent_boomerangs' && `active`}
                                    onClick={e => { setStatus('recent_boomerangs'); setGalleryTab("boomerangs") }}
                                  >Recent Boomerangs</span>
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="tab-content" id="pills-tabContent">
                        <div
                          className={`tab-pane fade ${eventStatus == 'most_viewed' ? `show active` : ''}`}
                          id="pills-home"
                          role="tabpanel"
                          aria-labelledby="pills-home-tab"
                        >
                          <div className="my-5 text-center col-md-12">
                            <b>Items Not Available</b>
                          </div>
                        </div>
                        <div
                          className={`tab-pane fade ${eventStatus == 'recent_photo' ? `show active` : ''}`}
                          id="pills-profile"
                          role="tabpanel"
                          aria-labelledby="pills-profile-tab"
                        >

                          {!loading ?
                            recentGallery.length > 0 ?
                              <RecentPhoto recentPhoto={recentGallery} />
                              :
                              <div className="my-5 text-center col-md-12">
                                <b>Items Not Available</b>
                              </div>
                            :
                            <div className="my-5 text-center col-md-12">
                              <span className="spinner-border" role="status" aria-hidden="true"></span>
                            </div>
                          }

                        </div>




                        <div
                          className={`tab-pane fade ${eventStatus == 'recent_video' ? `show active` : ''}`}
                          id="pills-contact"
                          role="tabpanel"
                          aria-labelledby="pills-contact-tab"
                        >

                          {!loading ?
                            recentGallery.length > 0 ?
                              ""
                              :
                              <div className="my-5 text-center col-md-12">
                                <b>Items Not Available</b>
                              </div>
                            :
                            <div className="my-5 text-center col-md-12">
                              <span className="spinner-border" role="status" aria-hidden="true"></span>
                            </div>
                          }
                        </div>

                        <div
                          className={`tab-pane fade ${eventStatus == 'recent_boomerangs' ? `show active` : ''}`}
                          id="pills-contact"
                          role="tabpanel"
                          aria-labelledby="pills-contact-tab"
                        >

                          {!loading ?
                            recentGallery.length > 0 ?
                              ""
                              :
                              <div className="my-5 text-center col-md-12">
                                <b>Items Not Available</b>
                              </div>
                            :
                            <div className="my-5 text-center col-md-12">
                              <span className="spinner-border" role="status" aria-hidden="true"></span>
                            </div>
                          }
                        </div>


                      </div>

                      {/* <div className="analytic-photos">
                        <ul className={`nav nav-pills`} id={`analytics-tab`} role="tablist">
                          <li className="nav-item" role="presentation">
                            <span
                              className="tab-item active"
                              id={`analytics-home-tab`}
                              href={`#analytics-home`}
                              role="tab"
                              data-toggle="tab"
                              aria-controls={`analytics-home`}
                              aria-selected="false"
                            >
                              Most Viewed
                          </span>
                          </li>
                          <li className="nav-item" role="presentation">
                            <span
                              className="tab-item"
                              id={`analytics-profile-tab`}
                              href={`#analytics-profile`}
                              role="tab"
                              data-toggle="tab"
                              aria-controls={`analytics-profile`}
                              aria-selected="false"
                              onClick={ (e) => setGalleryTab("photo")}
                            >
                              Recent Photos
                          </span>
                          </li>
                          <li className="nav-item" role="presentation">
                            <span
                              className="tab-item"
                              id={`analytics-contact-tab`}
                              href={`#analytics-contact`}
                              role="tab"
                              data-toggle="tab"
                              aria-controls={`analytics-contact`}
                              aria-selected="false"
                              onClick={ (e) => setGalleryTab("gif")}
                            >
                              Recent Gifs
                          </span>
                          </li>
                        </ul>
                        <div className="tab-content" id={`analytics-tabContent`}>
                          <div
                            className="tab-pane fade show active"
                            id={`analytics-home`}
                            role="tabpanel"
                            aria-labelledby={`analytics-home-tab`}
                          >
                            <div className="mt-3 gallery-body">
                              <div className="row">
                                <div className="col-12">
                                  <div className="gallery-items">

                                    <div className="mb-2 text-center gallery-item">
                                      <div className="image">
                                        Item Not Available
                                      </div>
                                    </div>
                                    
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="tab-pane fade show"
                            id={`analytics-profile`}
                            role="tabpanel"
                            aria-labelledby={`analytics-profile-tab`}
                          >
                            <div className="mt-3 gallery-body">
                              <div className="row">
                                <div className="col-12">
                                  <div className="gallery-items">

                                  {loading ? 
                                    <div className="my-5 text-center col-md-12">
                                      <span className="spinner-border" role="status" aria-hidden="true"></span>
                                    </div>
                                  : <RecentPhoto recentPhoto={recentGallery} /> }
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="tab-pane fade show"
                            id={`analytics-contact`}
                            role="tabpanel"
                            aria-labelledby={`analytics-contact-tab`}
                          >
                            <div className="mt-3 gallery-body">
                              <div className="row">
                                <div className="col-12">
                                  <div className="gallery-items">

                                    {loading ? 
                                      <div className="my-5 text-center col-md-12">
                                        <span className="spinner-border" role="status" aria-hidden="true"></span>
                                      </div>
                                    : <RecentGifs gif={recentGallery} /> }

                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> */}
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </Layout>
  )
}

export default Analytic
